(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sth-keyboard-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
    function init() {
      const root = document.getElementById('sth-keyboard-navigation');
      const dialog = root?.querySelector('#sth-keyboard-dialog');
      const launcher = document.querySelector('[data-sth-keyboard-launch]');
      if (!root || !dialog || !launcher || root.dataset.ready || typeof dialog.showModal !== 'function') return;
      const actions = Array.from(dialog.querySelectorAll('[data-sth-keyboard-action]'));
      const action = name => actions.find(element => element.dataset.sthKeyboardAction === name);
      const status = dialog.querySelector('[data-sth-keyboard-status]');
      let previousFocus = null;
      let restoreFocus = true;
      let searchRequest = 0;
      const visible = element => Boolean(element && element.isConnected && !element.closest('[hidden], [inert], [aria-hidden="true"]') && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
      const outside = selector => Array.from(document.querySelectorAll(selector)).find(element => !root.contains(element) && visible(element));
      function blocked() {
        if (Array.from(document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"]')).some(element => element !== dialog && visible(element))) return true;
        if (document.documentElement.matches('.m2a, .m6pn-open, .m6cp-open, .f8fl-open, .nav-hover, .search-compact-active, .search-full, .search-full-mode, .user-form-active')) return true;
        return Boolean(outside('.m6pn.toggle, .m6cp.toggle, [data-sth-search-panel]:not([hidden])'));
      }
      function filterTarget() {
        if (!['collection', 'search'].includes(root.dataset.pageType)) return null;
        return document.getElementById('filter') || (root.dataset.pageType === 'search' ? document.getElementById('sth-results-filters') : null);
      }
      function summaryTarget() {
        return root.dataset.pageType === 'product' ? document.querySelector('#content h1') : null;
      }
      function updateContext() {
        action('filters').closest('li').hidden = !filterTarget();
        action('product-summary').closest('li').hidden = !summaryTarget();
        action('main-content').closest('li').hidden = !document.getElementById('content');
      }
      function focusTarget(target) {
        if (!visible(target)) return false;
        const hadTabindex = target.hasAttribute('tabindex');
        if (!hadTabindex && !target.matches('a[href], button, input, select, textarea, [contenteditable="true"]')) {
          target.setAttribute('tabindex', '-1');
          target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
        }
        target.focus();
        return document.activeElement === target;
      }
      function close(restore = true) {
        restoreFocus = restore;
        if (dialog.open) dialog.close();
      }
      function open() {
        if (blocked()) return;
        searchRequest++;
        updateContext();
        status.textContent = '';
        previousFocus = document.activeElement;
        restoreFocus = true;
        dialog.showModal();
        action('search').focus();
      }
      function safeTrigger(element) {
        const event = new MouseEvent('click', { bubbles: true, cancelable: true, view: window });
        event.preventDefault();
        element.dispatchEvent(event);
      }
      function search() {
        const request = ++searchRequest;
        const input = document.getElementById('search_main');
        if (focusTarget(input)) return;
        const opener = outside('[aria-controls="search"]');
        if (!opener) { status.textContent = status.dataset.unavailable; return; }
        safeTrigger(opener);
        let tries = 0;
        function attempt() {
          if (request !== searchRequest || dialog.open) return;
          if (focusTarget(document.getElementById('search_main'))) return;
          if (++tries < 10) window.setTimeout(attempt, 50);
        }
        attempt();
      }
      function perform(name, event) {
        searchRequest++;
        if (name === 'product-summary' && !summaryTarget()) return;
        if (name === 'filters' && !filterTarget()) return;
        close(false);
        if (name === 'home' || name === 'shop-all') return;
        if (name === 'cart') {
          const trigger = outside('a[data-panel="cart"]');
          if (trigger) { event.preventDefault(); trigger.click(); }
          return;
        }
        event.preventDefault();
        if (name === 'search') search();
        if (name === 'product-summary') focusTarget(summaryTarget());
        if (name === 'main-content') focusTarget(document.getElementById('content'));
        if (name === 'filters') {
          const target = filterTarget();
          if (target.id === 'sth-results-filters') {
            const details = target.closest('details.sth-results-refine');
            if (details) details.open = true;
            const control = Array.from(target.querySelectorAll('input:not([type="hidden"]):not(:disabled), select:not(:disabled), button:not(:disabled), a[href]')).find(visible);
            focusTarget(control || target);
            return;
          }
          const opener = outside('a[href="#filter"], [aria-controls="filter"]');
          if (opener) safeTrigger(opener);
          else focusTarget(target);
        }
      }
      launcher.addEventListener('click', event => { event.preventDefault(); if (dialog.open) close(); else open(); });
      dialog.querySelector('[data-sth-keyboard-close]').addEventListener('click', () => close());
      dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
      dialog.addEventListener('close', () => {
        if (restoreFocus && visible(previousFocus)) previousFocus.focus();
        previousFocus = null;
      });
      dialog.addEventListener('click', event => {
        const target = event.target.closest('[data-sth-keyboard-action]');
        if (target && dialog.contains(target)) perform(target.dataset.sthKeyboardAction, event);
      });
      document.addEventListener('keydown', event => {
        if (event.defaultPrevented || event.repeat || event.isComposing || event.keyCode === 229 || event.ctrlKey || event.metaKey || event.getModifierState?.('AltGraph')) return;
        if (event.composedPath().some(element => element instanceof Element && (element.matches('input, textarea, select') || element.isContentEditable))) return;
        if (blocked()) return;
        if (dialog.open && event.key === 'Escape') {
          event.preventDefault();
          event.stopImmediatePropagation();
          close();
          return;
        }
        if (dialog.open && !event.altKey && ['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
          const available = actions.filter(visible);
          let index = available.indexOf(document.activeElement);
          if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = available.length - 1;
          else index = (index + (event.key === 'ArrowDown' ? 1 : -1) + available.length) % available.length;
          if (available[index]) { event.preventDefault(); available[index].focus(); }
          return;
        }
        if (!event.altKey) return;
        const code = event.code || (event.key === '/' ? 'Slash' : 'Key' + event.key.toUpperCase());
        let name = null;
        if (!event.shiftKey && code === 'Slash') name = 'search';
        if (event.shiftKey) name = { KeyH: 'home', KeyC: 'cart', KeyD: 'product-summary', KeyM: 'main-content', KeyZ: 'menu' }[code];
        if (!name || (name === 'product-summary' && !summaryTarget()) || (name === 'main-content' && !document.getElementById('content'))) return;
        event.preventDefault();
        if (name === 'menu') { if (dialog.open) close(); else open(); }
        else action(name).click();
      }, true);
      updateContext();
      if (/Mac|iPhone|iPad/.test(navigator.platform)) {
        const option = root.querySelector('[data-sth-keyboard-option]').textContent;
        root.querySelectorAll('[data-sth-keyboard-modifier]').forEach(element => { element.textContent = option; });
      }
      document.querySelectorAll('[data-sth-keyboard-content]').forEach(element => { element.setAttribute('accesskey', 'm'); });
      document.querySelectorAll('[data-sth-keyboard-content-key]').forEach(element => { element.textContent = 'm'; });
      launcher.hidden = false;
      launcher.style.removeProperty('display');
      launcher.setAttribute('aria-controls', dialog.id);
      launcher.setAttribute('aria-haspopup', 'dialog');
      root.dataset.ready = 'true';
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();
  })();
  } catch(e) { console.error(e); }
})();

})();
